import { z } from "zod";

export const fileSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  url: z.string().url(),
});

export const linkSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type FileData = z.infer<typeof fileSchema>;
export type LinkData = z.infer<typeof linkSchema>;
